export default {
  container: document.body,
  action: 'copy',
  text: '',
  md5: '',

  // 是否有数据
  hasData(type) {
    if (this.text.length < 2) {
      return false;
    }

    try {
      let data = JSON.parse(this.text);
      return bi.isObject(data) && data.type == type;
    } catch (e) {
      return false;
    }
  },

  // 获取数据
  getData() {
    try {
      let data = JSON.parse(this.text);
      if (bi.isObject(data) && data.type != undefined) {
        return data;
      }
    } catch (e) {
    }
    return null;
  },

  // 复制
  copy(text) {
    let md5 = bi.md5(text);
    if (md5 == this.md5) {
      return true;
    }

    this.md5 = md5;
    this.text = text;
    this.action = 'copy';
    this.selectFake();
  },

  // 剪切
  cut(text) {
    this.text = text;
    this.action = 'cut';
    this.selectFake();
  },

  // 清除粘贴板内容
  clear(text = ' ') {
    this.text = text;
    this.action = 'copy';
    this.selectFake();
  },

  // 是否支持
  isSupported() {
    const actions = ['copy', 'cut', 'paste'];
    let support = !!document.queryCommandSupported;

    actions.forEach((action) => {
        support = support && !!document.queryCommandSupported(action);
    });

    return support;
  },

  getPasteData(e) {
    var cbd = e.clipboardData;
    var ua = window.navigator.userAgent;

    // 如果是 Safari 直接 return
    if (!(cbd && cbd.items)) {
      return null;
    }

    // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
    if (cbd.items && cbd.items.length === 2 && cbd.items[0].kind === "string" && cbd.items[1].kind === "file" &&
        cbd.types && cbd.types.length === 2 && cbd.types[0] === "text/plain" && cbd.types[1] === "Files" &&
      ua.match(/Macintosh/i) && Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49){
      return null;
    }
    let text = cbd.getData('Text');
    if (text.replace(/\s+/g, '') != '') {
      let obj = null;
      try {
        obj = JSON.parse(text);
      } catch (e) {
        //console.log(e);
      }
      if (bi.isObject(obj) && obj.type && obj.data) {
        return obj;
      } else {
        return {type:'string', data: text};
      }
    }

    for (var i = 0; i < cbd.items.length; i++) {
      var item = cbd.items[i];
      if (item.kind == "file") {
        var blob = item.getAsFile();
        if (blob.size === 0) {
          break;
        }

        return {type:'blob', data: blob};
      }
      // else if (item.kind == "string") {
      //   item.getAsString(str => {
      //     if (str.replace(/\s+/g, '') == '') {
      //       return false;
      //     }
      //     let obj = null;
      //     try {
      //       obj = JSON.parse(str);
      //     } catch (e) {
      //       //console.log(e);
      //     }
      //     if (obj && obj.type && obj.data) {
      //       fun(obj);
      //     } else {
      //       fun({type:'string', data: str});
      //     }
      //   });
      //   break;
      // }
    }
    //this.clear();

    return null;
  },

  /**
   * Creates a fake textarea element, sets its value from `text` property,
   * and makes a selection on it.
   */
  selectFake() {
    const isRTL = document.documentElement.getAttribute('dir') == 'rtl';

    this.removeFake();

    this.fakeHandlerCallback = () => this.removeFake();
    this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

    this.fakeElem = document.createElement('textarea');
    // Prevent zooming on iOS
    this.fakeElem.style.fontSize = '12pt';
    // Reset box model
    this.fakeElem.style.border = '0';
    this.fakeElem.style.padding = '0';
    this.fakeElem.style.margin = '0';
    // Move element out of screen horizontally
    this.fakeElem.style.position = 'absolute';
    this.fakeElem.style[ isRTL ? 'right' : 'left' ] = '-9999px';
    // Move element to the same position vertically
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.fakeElem.style.top = `${yPosition}px`;

    this.fakeElem.setAttribute('readonly', '');
    this.fakeElem.value = this.text;

    this.container.appendChild(this.fakeElem);

    this.selectedText = this.select(this.fakeElem);
    this.execCommand();
  },

  /**
   * Only removes the fake element after another click event, that way
   * a user can hit `Ctrl+C` to copy because selection still exists.
   */
  removeFake() {
    if (this.fakeHandler) {
        this.container.removeEventListener('click', this.fakeHandlerCallback);
        this.fakeHandler = null;
        this.fakeHandlerCallback = null;
    }

    if (this.fakeElem) {
        this.container.removeChild(this.fakeElem);
        this.fakeElem = null;
    }
  },

  /**
   * Executes the copy operation based on the current selection.
   */
  execCommand() {
    let succeeded;

    try {
      //console.log("document.execCommand(", this.action, ")")
      succeeded = document.execCommand(this.action);
    }
    catch (err) {
      succeeded = false;
    }

    return succeeded;
  },

  /**
   * 选中元素的内容
   */
  select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
  }
}